import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const breadcrumbData = [
    { '@type': 'ListItem' as const, position: 1, name: '黑桃视频', item: '/' },
    ...items.map((item, index) => ({
      '@type': 'ListItem' as const,
      position: index + 2,
      name: item.label,
      ...(item.to ? { item: item.to } : {}),
    })),
  ];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbData,
  };

  const categoryMap = Object.fromEntries(categories.map((c) => [c.slug, c.name]));

  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-500 py-3">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">
        <i className="ri-home-4-line"></i> 首页
      </Link>
      {items.map((item, idx) => (
        <span key={idx} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-xs"></i>
          {item.to ? (
            <Link
              to={item.to}
              className="hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              {categoryMap[item.label] || item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium whitespace-nowrap">
              {categoryMap[item.label] || item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}